module.exports = __webpack_public_path__ + "img/IMG-20230301-WA0010.2dec0f38.jpg";